module.exports = __webpack_public_path__ + "static/img/7.945b519.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/sp/7.png
// module id = cVbf
// module chunks = 0